import styled from 'styled-components';

export const OrdersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100% - 181px);
  min-height: calc(100vh - 181px);
  padding: 24px 24px 51px;
  background-color: ${({ theme }) => theme.colors.grey100};
`;

export const LoaderWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
`;

export const PaginationWrapper = styled.div`
  padding: 24px 0;
  background-color: ${({ theme }) => theme.colors.white};
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
`;
